<template>
  <div class="grid">
    <app-question :data-heading="dataInteraction.descricao"
                  :data-color="dataInteraction.estilo.question.color"></app-question>

    <div class="options grid-center">
      <template v-for="(option, index) in dataInteraction.opcoes">
        <button class="clear-connections btn btn-stretch btn-extra-round text-bold"
                v-if="isShowingLinks && hasActiveLinks({ option: option })"
                :key="index + 10"
                @click="clearConnections($event, option)">Limpar conexões</button>
        <button class="btn btn-round text-bold"
                :id="index"
                :class="{'mb-3': index !== dataInteraction.opcoes.length - 1}"
                :style="buttonStyle(dataInteraction.estilo)"
                :key="index"
                @click="(event) => showLinks({event, option, interaction})">
          {{option.nome}}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
    import AppQuestion from './Question'
    import buttonStyle from '../mixins/button-style'
    import mode from '../mixins/mode'
    import linkable from '../mixins/linkable'

    export default {
        components: {
            AppQuestion,
        },

        props: {
            dataInteraction: {
                type: Object,
                required: true
            }
        },

        mixins: [buttonStyle, mode, linkable]
    }
</script>

<style lang="scss" scoped>
.grid {
  .btn {
    &.clear-connections {
      position: fixed;
      bottom: 15px;
      left: 40%;
      min-width: 0 !important;
      width: 20% !important;
      background-color: #2a7155;
      z-index: 10000;
      color: white;
      min-width: 0;

      &:hover {
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }
}
</style>
